// extracted by mini-css-extract-plugin
export default {"avatar_container":"-ab-n1oiGx-s2d24Xcem3Q==","avatar_status":"jkK9vaf9tkBJj5v0qcD-kg=="};